import React from 'react';
import { styled } from 'linaria/react';

const VideoFrameWrapper = styled('div')`
  position: relative;
  padding-bottom: ${props => props.bottompadding}%;
  margin-bottom: 0px;
  width: 100% !important;
  height: auto !important;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
  }
`;
export const VimeoVideo = ({ videoUrl, ratio = '16:9', autoplay = true }) => {
  const vUrl = videoUrl;
  const auto = autoplay;
  const videoRatio = ratio;
  const videoID = vUrl?.split('https://vimeo.com/')?.[1];

  if (!videoID) return null;

  const convertBoolToInt = b => {
    return b ? 1 : 0;
  };

  const intFromAutoPlay = convertBoolToInt(auto);
  const playerVideoUrl = `https://player.vimeo.com/video/${videoID}?autoplay=${intFromAutoPlay}&loop=${intFromAutoPlay}&title=0&byline=0&portrait=0&controls=${!auto}&muted=${auto}`;

  const videoRatioToPercent = ratio => {
    const widthAndHeight = ratio?.split(':');
    if (widthAndHeight?.[0] && widthAndHeight?.[1]) {
      const width = widthAndHeight?.[0];
      const heigth = widthAndHeight?.[1];
      return (heigth / width) * 100;
    }
    return null;
  };

  const videoProps = {
    // width: '560',
    // height: '315'
    height: 'auto',
    width: '100%'
  };

  return (
    <VideoFrameWrapper bottompadding={videoRatioToPercent(videoRatio)}>
      <iframe title={`Video ${videoID}`} {...videoProps} src={playerVideoUrl} />
    </VideoFrameWrapper>
  );
};
